import React from "react";
import "./ReturnAndRefund.scss";

const ReturnAndRefund = () => {
  return (
    <div>
      <div className="RNR-main">

        <div className="RNR-outer">
          <div className="RNR-part">
            <div className="RNR-inner">
              <h1> Return and Refund Policy</h1>
              <p>
                At RAER, we prioritize your satisfaction with our products. Our
                Return and Refund Policy is designed to make the return process
                as simple and hassle-free as possible.
              </p>
              <p>
                You can return any product purchased from our official website
                within 30 days from the shipping date. The product must be in
                its original condition, unworn, and with all tags attached.
              </p>
              <p>
                Refunds will be processed within 5-7 working days from the date
                we receive the returned product. Please note that the actual
                refund timeline may vary depending on your payment method and
                financial institution.
              </p>
            </div>
            <div className="RNR-inner">
              <h1>Refund Process:</h1>
              <h3>1.Full Refund (UPI/Credit Card/Debit Card)</h3>
              <p>
                For orders paid via UPI, Credit Card, or Debit Card, you are
                eligible for a full refund. The refund will be processed to the
                original payment method.
              </p>
              <h3>2.Store Credit (Cash on Delivery):</h3>
              <p>
                If your order was paid via Cash on Delivery (COD), the refund
                will be issued in the form of RAER points or store credit, which
                can be used for future purchases on our website.
              </p>
            </div>
            <div className="RNR-inner">
              <h1>Return Procedure:</h1>
              <p>1. Log in to your RAER account on our official website.</p>
              <p>
                2. Go to the “Order History” section and select the order
                containing the item you wish to return.
              </p>
              <p>
                3. Click on the “Return Items” button and follow the on-screen
                instructions to complete the return process.
              </p>
            </div>
            <div className="RNR-inner">
              <h1>Return Shipping:</h1>
              <p>
                There are no charges for return shipping. We want to ensure a
                convenient and cost-free return experience for our customers.
              </p>
            </div>
            <div className="RNR-inner">
              <h1>RAER Points/Store Credit:</h1>
              <p>
                RAER points or store credit will be applied to your RAER account
                and can be used for future purchases. These points do not expire
                and offer flexibility in choosing your next item.
              </p>
            </div>
            <div className="RNR-inner">
              <h1>Contact Information:</h1>
              <p>
                If you have any questions or concerns about our Return and
                Refund Policy, please reach out to our customer support team at
                [customer support email] or [customer support phone number].
              </p>
              <p>
                RAER reserves the right to update or modify this policy at any
                time without prior notice. We encourage our customers to review
                the policy periodically for any changes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnAndRefund;
